module.exports = __webpack_public_path__ + "static/fishball-7d6e2de51a85deac8258c6ceb5b92943.jpg";